import { render, staticRenderFns } from "./CreateFields.vue?vue&type=template&id=ea65cc7a"
import script from "./CreateFields.vue?vue&type=script&lang=js"
export * from "./CreateFields.vue?vue&type=script&lang=js"
import style0 from "./CreateFields.vue?vue&type=style&index=0&id=ea65cc7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports